import './bluefirelights/style';
import FormStructure from './bluefirelights/form_structure';

export default FormStructure;